<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="generatProfit">生成工资</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh" @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total"
      :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template slot="royfleet" slot-scope="params">
        <span>{{ params.params.royfleet }}%</span>
      </template>
    </Table>

    <Dialog class="dialog" ref="dialog" :title="title" @closed="dialogClosed">
      <template #default>
        <el-form class="searchForm" :model="modalSearchForm">
          <FormItem v-for="(c, i) in modalSearchFormCtrl" :key="'msformItem' + i" :viewMode="false" :config="c"
            :options="c.options" :inputValue="modalSearchForm[c.keyName]" @onChange="onModalSearchFormChange" />
        </el-form>

        <div class="btns">
          <el-button type="primary" @click="onModalSubmit">确 定</el-button>
          <el-button @click="hideDialog">取 消</el-button>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import { mapState, mapMutations } from "vuex";
import Wxts from '../../../components/Wxts.vue';
export default {
  name: "FinanceEstimatedProfit",
  components: { Wxts },
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'fwages',
      breadcrumb: [
        { name: "财务管理" },
        { name: "车队长工资表" },
      ],
      wxtsList: [
        {
          name: '车队净利润：该队长下所有车辆本月净利润之和。'
        },
        {
          name: '提成百分比：可在【系统设置】',
          path: '/system/baseSalary',
          pathName: '【工资提成】',
          tailName: '处设置车队长提成比例。',
        },
        {
          name: '提成工资=(车队净利润-车队长提成初始利润额)×车队长提成比例。'
        },
        {
          name: '基本工资：可在【系统设置】',
          path: '/system/baseSalary',
          pathName: '【工资提成】',
          tailName: '中设置车队长工资。',
        },
        {
          name: '预计工资总额=提成工资+车队长基本工资。'
        }
      ],
      formInline: {
        fleet: '',
        month: '',
      },
      formCtrl: [
        {
          ...this.ctrls.fleet,
          options: [],
        },
        {
          ...this.ctrls.month,
        },
      ],
      cols: [
        { keyName: "name", label: "姓名", minwidth: 110 },
        { keyName: "basefleet", label: "基本工资", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "carmoney", label: "车队净利润", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "royfleet", label: "提成百分比", align: 'right', className: 'pr30', minwidth: 120, slot: 'royfleet' },
        { keyName: "fleet_eswage", label: "提成工资", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "sum_wage", label: "预计工资总额", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      getTotalProperty: [
        'carmoney',
        'ticheng',
        'eswage',
        'sum_wage',
        'fleet_eswage',
      ],
      btns: [
        // {
        //   title: '查看当月运单',
        //   img: require('@/assets/img/icon_order.png'),
        //   unimg: require('@/assets/img/icon_order_hover.png'),
        //   cb: ({ month, fleet }) => {
        //     this.$router.push(
        //       `/finance/monthorderfleet?month=${month}&fleet=${fleet}`
        //     );
        //   },
        // },
      ],
      title: '车队长预计工资生成',
      modalSearchForm: {},
      modalSearchFormCtrl: [
        {
          label: "月份选择：",
          keyName: "month",
          type: "select",
          options: []
        },
      ],
      modalList: [],
      checkedIds: [],
      checkAll: false,
      isIndeterminate: false,
      team: [],
      baseParams: ['month'],
    };
  },
  computed: {
    ...mapState([
      'store'
    ]),
  },
  methods: {
    ...mapMutations([
      'setState'
    ]),
    generatProfit() {
      this.showDialog()
    },
    onModalSearchFormChange({ key, value }) {
      // console.log(key, value)
      this.modalSearchForm[key] = value;
      console.log({ ...this.modalSearchForm })
    },
    handleCheckAllChange(val) {
      const arr = this.modalList.map(v => v.license)
      // console.log(val)
      this.checkedIds = val ? arr : [];
      this.isIndeterminate = false;
    },
    onCheckChange(v) {
      // console.log(v)
      // console.log(this.checkedIds)
      let n = v.length
      this.checkAll = n === this.modalList.length
      this.isIndeterminate = n > 0 && n < this.modalList.length
    },
    onModalSubmit() {
      this.loading = true
      let url = `${this.baseUrl}/addedu`;
      const params = {
        userid: this.user.id,
        ...this.modalSearchForm,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList()
          this.hideDialog()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    dialogClosed() { },
    setOptions({ month, team }) {
      this.modalSearchFormCtrl[0].options = month.map(v => {
        return {
          label: v,
          value: v,
        }
      })
      this.modalSearchForm.month = month[0]

      this.formCtrl.map(v => {
        if (v.keyName == 'fleet') {
          this.setCtrlOption(v, team, 'nickname')
        }
      })
    },
  },
  created() {
    this.MONTH = this.LAST_MONTH
    this.$set(this.formInline, 'month', this.LAST_MONTH)
  },
  mounted() {
    this.getList()
    this.getOptions()
  },
};
</script>

<style lang="less" scoped>
.dialog {
  /deep/ .el-dialog {
    width: 300px;
    height: 250px;

    .el-dialog__body {
      padding: 11px 20px 30px;
    }
  }

  .content-h {
    height: 350px;
    overflow-x: hidden;

    /deep/ .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    /deep/ .is-horizontal {
      display: none;
    }
  }

  .searchForm {
    display: flex;

    .checkAll {
      padding: 10px 30px 10px 0px;
    }

    /deep/ .el-form-item {
      .el-form-item__content {
        .el-input {
          input {
            background: #F2F6FC;
          }
        }
      }

      &:not(:first-of-type) {
        margin-left: 15px;
      }
    }
  }

  .btns {
    margin: 0;
    text-align: center;
    margin-top: 30px;
  }
}
</style>
